import React from 'react';
import PropTypes from 'prop-types';
import { withFormik } from 'formik';
import ModalBody from '../Global/Modals/ModalBody';
import ModalPadding from '../Global/Modals/ModalPadding';
import ModalFooter from '../Global/Modals/ModalFooter';
import TextInput from '../Global/Forms/TextInput';
import Button from '../Global/Buttons/Button';
import Form from "../Global/Forms/Form";
import ErrorText from "../Global/Forms/ErrorText";

const EditFolderForm = ({
  submitting,
  onDeleteFolderClick,
  foldersInLocation,
  inputRef,
  // Formik props
  values,
  handleChange,
}) => {
  const nameExists = foldersInLocation.filter(item => item.title === values.title).length > 0;
  return (
    <Form>
      <ModalBody>
        <ModalPadding>
          <TextInput
            name="title"
            label="Name"
            onChange={handleChange}
            value={values.title}
            inputRef={inputRef}
            maxLength={30}
            required
          />

          {nameExists && <ErrorText>A folder with this title already exists</ErrorText>}

        </ModalPadding>

        <ModalPadding>
          <div className="form-group">
            <span className="faux-label">Delete folder?</span>
            <p className="like-small color-grey">Any of your own content in this folder will still be available from your
              My Content page</p>
            <Button onClick={onDeleteFolderClick} size="s" classes="btn--destructive">Delete folder</Button>
          </div>
        </ModalPadding>
      </ModalBody>

      <ModalFooter>
        <Button type="submit" loading={submitting} disabled={!values.title || nameExists}>Save</Button>
      </ModalFooter>
    </Form>
  );
};

EditFolderForm.propTypes = {
  submitting: PropTypes.bool.isRequired,
  onDeleteFolderClick: PropTypes.func.isRequired,
  foldersInLocation: PropTypes.array.isRequired,
  inputRef: PropTypes.func,
  // Formik
  values: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
};

const FormikEditFolderForm = withFormik({
  enableReinitialize: true,
  mapPropsToValues({ folder }) {
    return {
      title: folder.title || ``,
    };
  },
  handleSubmit(values, bag) {
    bag.props.onSubmit(values);
  },
})(EditFolderForm);

export default FormikEditFolderForm;



// WEBPACK FOOTER //
// ./library/app/components/Folders/EditFolderForm.js